// import axios from '../../api/config';
import { authHeader } from './auth-header';
import userApi from '../../api/userApi';

export const userService = {
    login,
    logout,
    register,
    getAll,
};

function login(email, password) {

    return userApi.login(email, password)
        .then(user => {
            // login successful if there's a jwt token in the response
            if (user.data.token) {
                
                // store user details and jwt token in local storage to keep user logged in between page refreshes
                localStorage.setItem('user', JSON.stringify(user.data));
            }
            return user;
        })
}

function logout() {    
    return userApi.logoutUser({}); 
}

function register(user) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(user)
    };
    return fetch(`/users/register`, requestOptions).then(handleResponse);
}

function getAll() {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };
    return fetch(`/users`, requestOptions).then(handleResponse);
}

function handleResponse(response) {
    return response.text().then(text => {
        const data = text && JSON.parse(text);
        if (!response.ok) {

            let errMsg = null

            if (response.status === 400) {
                errMsg = "Email ou mot de passe incorrect"
            }

            if (response.status === 401) {
                // auto logout if 401 response returned from api
                errMsg = "Impossible de se connecter";
            }

            if (response.status === 403) {
                errMsg = 'Votre Compte n\'est plus actif'
            }
            const error = (data && data.message) || errMsg;
            return Promise.reject(error);
        }
        return data;
    });
}